import { api } from '@sentinel/web-core';
import type {
  LoraCoverage,
  MeshNode,
  MeshNodeBind,
  Station,
  StationCreate,
  StationCredentials,
  StationUpdate,
} from '@sentinel/shared';

/** Connettività (ADR 0026): stations, their keys, the Meshtastic nodes, the measured LoRa
 *  coverage of a mission. */
export const connectivityEndpoints = {
  stations: () => api<{ items: Station[] }>('/stations'),
  createStation: (body: StationCreate) =>
    api<StationCredentials>('/stations', { method: 'POST', body }),
  updateStation: (stationId: string, body: StationUpdate) =>
    api<Station>(`/stations/${stationId}`, { method: 'PATCH', body }),
  renewKeys: (stationId: string) =>
    api<StationCredentials>(`/stations/${stationId}/keys`, { method: 'POST' }),
  archiveStation: (stationId: string) =>
    api<undefined>(`/stations/${stationId}`, { method: 'DELETE' }),
  meshNodes: () => api<{ items: MeshNode[] }>('/mesh-nodes'),
  bindNode: (nodeId: string, body: MeshNodeBind) =>
    api<undefined>(`/mesh-nodes/${nodeId}/device`, { method: 'PUT', body }),
  loraCoverage: (missionId: string) => api<LoraCoverage>(`/missions/${missionId}/lora-coverage`),
};
